import {
    DEALERGETUSERMASTERLIST_SUCCESS,
    DEALERGETUSERMASTERLIST_FAILED,
    RESET_DEALERGETUSERMASTERLIST,
    LOADING_DEALERGETUSERMASTERLIST,
    NETWORK_ERROR_DEALERGETUSERMASTERLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETUSERMASTERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETUSERMASTERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETUSERMASTERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETUSERMASTERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETUSERMASTERLIST:
            return (state = initialState);
        default:
            return state;
    }
};
